// import React, { useState, useEffect } from "react";
// import CustomButton from "./CustomButton";
// import { Translate } from "./LanguageChanger";

// const SliderBanner = ({
//   bannerdata,
//   shouldFocusSlider,
//   shouldFocusToGrid,
//   FocusHandler,
//   navigateToScreen,
//   callBack,
//   lastFocusedElement3,
//   rememberFocus,
//   setRememberFocus,
// }) => {
//   const [currentIndex, setCurrentIndex] = useState(currentIndex || 0);
//   const [data, setData] = useState(bannerdata);
//   const [shouldFocusToSlider, setShouldFocusToSlider] = useState(false);
//   // const [currentRowIndex, setCurrentRowIndex] = useState(rememberFocus?.row || 0);
//     const [selectedIndex, setSelectedIndex] = useState(
//       rememberFocus ?  currentIndex  : 0
//     );

//   let resolution = window.innerWidth > 768 ? "FHD" : "HD";

//   function goToNext() {
//     if (currentIndex < data.length - 1) {
//       setCurrentIndex((prev)=>prev+1);
//     }
//   };

//   function goToPrevious(){
//     console.log(currentIndex,"custom Class")

//     if (currentIndex > 0) {
//       console.log(currentIndex,"custom Class 1")
//       setCurrentIndex((prev)=>prev-1);
//     }else {
//       console.log(currentIndex,"custom Class 2")
//       callBack("AnimatedGrid", true);
//       // setCurrentIndex(data.length - 1);
//     }
//   };

//   const goToSlide = (index) => {
//     setCurrentIndex(index);
//   };

//   function formatUnixToDate(unixTimestamp) {
//     const date = new Date(unixTimestamp * 1000); // Convert Unix timestamp to milliseconds

//     const day = date.getDate();
//     const monthNames = [
//       "Jan",
//       "Feb",
//       "Mar",
//       "Apr",
//       "May",
//       "Jun",
//       "Jul",
//       "Aug",
//       "Sep",
//       "Oct",
//       "Nov",
//       "Dec",
//     ];
//     const month = monthNames[date.getMonth()];
//     const year = date.getFullYear();

//     const hours = date.getHours();
//     const minutes = date.getMinutes();
//     const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
//     const ampm = hours >= 12 ? "PM" : "AM";
//     const formattedHours = hours % 12 || 12; // Convert to 12-hour format

//     const ordinalSuffix = (n) => {
//       if (n > 3 && n < 21) return "th"; // Covers 11th to 19th
//       switch (n % 10) {
//         case 1:
//           return "st";
//         case 2:
//           return "nd";
//         case 3:
//           return "rd";
//         default:
//           return "th";
//       }
//     };

//     const dayWithSuffix = `${day}${ordinalSuffix(day)}`;

//     return `${dayWithSuffix} ${month} ${year}, ${formattedHours}:${formattedMinutes} ${ampm}`;
//   }

//   function isTimeExpired(unixTimestamp) {
//     const currentTime = Math.floor(Date.now() / 1000); // Current time in Unix (seconds)
//     return currentTime > unixTimestamp;
//   }

//   useEffect(() => {
//     const uniqueList = bannerdata.filter(
//       (item, index, self) => index === self.findIndex((t) => t.id === item.id)
//     );
//     setData(() => uniqueList);
//     if (setRememberFocus) {
//       setRememberFocus({ currentIndex });
//     }
//   }, [bannerdata]);

//   useEffect(() => {
//     if (!shouldFocusSlider) return;

//     const bannerKeyHandler = (event) => {
//       if (event.keyCode === 13) {
//         console.log("currentIndex", data[currentIndex], currentIndex);
//         navigateToScreen("DetailsScreen", data[currentIndex]);
//         lastFocusedElement3();
//       } else if (event.keyCode === 39) {
//         goToNext();
//       } else if (event.keyCode === 37) {
//         goToPrevious();
//       } else if (event.keyCode === 40) {
//         console.log("shouldFocusToGrid", shouldFocusToGrid);
//         FocusHandler("AnimatedGrid");
//         console.log("shouldFocusToGrid", shouldFocusToGrid);
//       } else if (event.keyCode === 38) {
//         FocusHandler("RowList");
//       } else if (event.keyCode === 8 || event.keyCode === 10009 || event.keyCode === 461) {
//         // console.log("shouldFocusToGrid", shouldFocusToGrid);
//         callBack("AnimatedGrid", true);
//         // FocusHandler("AnimatedGrid");
//         // console.log("shouldFocusToGrid", shouldFocusToGrid);
//       }
//     };

//     window.addEventListener("keydown", bannerKeyHandler);

//     return () => {
//       window.removeEventListener("keydown", bannerKeyHandler);
//     };
//   }, [shouldFocusSlider, currentIndex, data, FocusHandler, navigateToScreen]);

//   return (
//     <div
//       className={shouldFocusToGrid ? "slide-up-hide" : "slide-down-show"}
//       style={{
//         position: "relative",
//         width: "90vw",
//         height: "800px",
//         overflow: "hidden",
//         padding: "20px",
//         marginBottom: "3rem",
//       }}
//     >
//       {data?.map((image, index) => (
//         <img
//           key={index}
//           src={image.banner_url}
//           alt={`Slide ${index + 1}`}
//           style={{
//             display: index === currentIndex ? "block" : "none",
//             width: "100%",
//             height: "100%",
//             objectFit: "fill",
//             borderRadius: "25px",
//           }}
//         />
//       ))}

//       <div
//         style={{
//           position: "absolute",
//           top: "20px",
//           left: "20px",
//           right: "20px",
//           bottom: "20px",
//           borderRadius: "25px",
//           background: "linear-gradient(to top right, #000037, #FFFFFF)",
//           zIndex: 1,
//           opacity: 0.4,
//         }}
//       />

//       {/* Title for current slide */}
//       {data[currentIndex] && (
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             paddingLeft: "7%",
//             top: "15rem",
//             zIndex: 2,
//             color: "#fff",
//             width: "30vw",
//             position: "absolute",
//           }}
//         >
//           <h2
//             style={{
//               fontWeight: "bold",
//               fontSize: "4rem",
//               lineHeight: "1",
//               textTransform: "uppercase",
//               zIndex: 2,
//               margin: "0",
//             }}
//           >
//             {data[currentIndex].title}
//           </h2>

//           <p
//             style={{
//               fontSize: "1.5rem",
//               lineHeight: "1.5",
//             }}
//           >
//             {`${data[currentIndex]?.description[0]?.content.slice(0, 100)}...`}
//           </p>

//           <p
//             style={{
//               fontSize: "1.5rem",
//               lineHeight: "1.5",
//             }}
//           >
//             {`${data[currentIndex]?.genre_titles?.split(",").join(" | ")}`}
//           </p>

//           <CustomButton
//             isLiveText={
//               data[currentIndex]?.is_live === 0 &&
//               data[currentIndex]?.live_date_time > 1
//             }
//             navigateTo="/login"
//             fontSize={resolution === "FHD" ? "26px" : "18px"}
//             defaultSelected={true}
//             width={resolution === "FHD" ? "254px" : "169px"}
//             height={resolution === "FHD" ? "80px" : "53px"}
//             className="carousel-image"
//             style={{
//               opacity: 1,
//               transition: "opacity 1s",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: "0.8rem",
//               fontWeight: "bold",
//               zIndex: 2,
//               border: "none",
//               position: "relative",
//               margin: "0",
//             }}
//           >
//             <div>
//               {(data[currentIndex]?.live_date_time &&
//                 data[currentIndex]?.live_end_time > 1) ||
//               (data[currentIndex]?.live_date_time === 0 &&
//                 data[currentIndex]?.live_end_time === 0) ? (
//                 <img
//                   src="./assets/playbuttonicon.png"
//                   style={{
//                     width: resolution === "FHD" ? "26px" : "18px",
//                     height: resolution === "FHD" ? "31px" : "22px",
//                   }}
//                   alt="Play Button"
//                 />
//               ) : null}
//             </div>

//             <div>
//               {data[currentIndex]?.media_type === 1 ? (
//                 <Translate langKey="Listennow" />
//               ) : data[currentIndex]?.is_live === 0 ? (
//                 data[currentIndex]?.live_date_time ? (
//                   isTimeExpired(data[currentIndex]?.live_date_time) ? (
//                     "Watch since"
//                   ) : (
//                     `Begins on ${formatUnixToDate(
//                       data[currentIndex]?.live_date_time
//                     )}`
//                   )
//                 ) : (
//                   <Translate langKey="Watchnow" />
//                 )
//               ) : (
//                 <Translate langKey="Watchnow" />
//               )}
//             </div>
//           </CustomButton>
//         </div>
//       )}

//       {/* Navigation Buttons */}
//       {/* <button
//         onClick={goToPrevious}
//         style={{
//           position: "absolute",
//           left: 0,
//           top: "50%",
//           transform: "translateY(-50%)",
//           fontSize: "2rem",
//           background: "transparent",
//           border: "none",
//           cursor: "pointer",
//         }}
//       >
//         ❮
//       </button>
//       <button
//         onClick={goToNext}
//         style={{
//           position: "absolute",
//           right: 0,
//           top: "50%",
//           transform: "translateY(-50%)",
//           fontSize: "2rem",
//           background: "transparent",
//           border: "none",
//           cursor: "pointer",
//         }}
//       >
//         ❯
//       </button> */}

//       {/* Dots */}
//       <div
//         style={{
//           position: "absolute",
//           bottom: "50px",
//           left: "50%",
//           transform: "translateX(-50%)",
//           display: "flex",
//           gap: "10px",
//           zIndex: 2,
//         }}
//       >
//         {data.map((_, index) => (
//           <span
//             key={index}
//             onClick={() => goToSlide(index)}
//             style={{
//               height: "12px",
//               width: "12px",
//               borderRadius: "50%",
//               display: "inline-block",
//               backgroundColor:
//                 index === currentIndex && shouldFocusSlider
//                   ? "#EC008C"
//                   : "#FFF",
//               cursor: "pointer",
//               transition: "background-color 0.3s ease",
//             }}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default SliderBanner;

// import React, { useState, useEffect, useRef } from "react";
// import CustomButton from "./CustomButton";
// import { Translate } from "./LanguageChanger";
// import { getContentDetails } from "../services/services";

// let contentDetails = null;

// const SliderBanner = ({
//   sliderData,
//   shouldFocusSlider,
//   shouldFocusToGrid,
//   FocusHandler,
//   navigateToScreen,
//   callBack,
//   rememberFocus,
//   setRememberFocus,
//   lastFocusedElement3,
// }) => {
//   const sliderRef = useRef(null);
//   console.log(
//     "SliderBanner data",
//     rememberFocus,
//     "nextFunc",
//     lastFocusedElement3
//   );
//   const [currentIndex, setCurrentIndex] = useState(
//     rememberFocus?.sliderIndex !== undefined ? rememberFocus.sliderIndex : 0
//   );
//   // const [data, setData] = useState(sliderData);

//   let resolution = window.innerWidth > 768 ? "FHD" : "HD";

//   // Initialize currentIndex from rememberFocus when component mounts
//   useEffect(() => {
//     if (rememberFocus?.sliderIndex !== undefined) {
//       setCurrentIndex(rememberFocus.sliderIndex);
//     }
//   }, [rememberFocus]);

//   function goToNext() {
//     if (currentIndex < sliderData[0]?.list?.filter(
//       (item) => ((item?.banner_type === 0))
//     ).length - 1) {
//       const newIndex = currentIndex + 1;
//       setCurrentIndex(newIndex);
//       // Update rememberFocus with the new index
//       setRememberFocus((prev) => ({ ...prev, sliderIndex: newIndex }));
//     }
//   }

//   function goToPrevious() {
//     if (currentIndex > 0) {
//       const newIndex = currentIndex - 1;
//       setCurrentIndex(newIndex);
//       setRememberFocus((prev) => ({ ...prev, sliderIndex: newIndex }));
//     } else {
//       callBack("AnimatedGrid", true);
//     }
//   }

//   const goToSlide = (index) => {
//     setCurrentIndex(index);
//     setRememberFocus((prev) => ({ ...prev, sliderIndex: index }));
//   };

//   function formatUnixToDate(unixTimestamp) {
//     const date = new Date(unixTimestamp * 1000);
//     const day = date.getDate();
//     const monthNames = [
//       "Jan",
//       "Feb",
//       "Mar",
//       "Apr",
//       "May",
//       "Jun",
//       "Jul",
//       "Aug",
//       "Sep",
//       "Oct",
//       "Nov",
//       "Dec",
//     ];
//     const month = monthNames[date.getMonth()];
//     const year = date.getFullYear();
//     const hours = date.getHours();
//     const minutes = date.getMinutes();
//     const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
//     const ampm = hours >= 12 ? "PM" : "AM";
//     const formattedHours = hours % 12 || 12;

//     const ordinalSuffix = (n) => {
//       if (n > 3 && n < 21) return "th";
//       switch (n % 10) {
//         case 1:
//           return "st";
//         case 2:
//           return "nd";
//         case 3:
//           return "rd";
//         default:
//           return "th";
//       }
//     };

//     const dayWithSuffix = `${day}${ordinalSuffix(day)}`;
//     return `${dayWithSuffix} ${month} ${year}, ${formattedHours}:${formattedMinutes} ${ampm}`;
//   }

//   function isTimeExpired(unixTimestamp) {
//     const currentTime = Math.floor(Date.now() / 1000);
//     return currentTime > unixTimestamp;
//   }

//   console.log(sliderData, "SLiderDAta");

//   // useEffect(() => {
//   //   const uniqueList = sliderData[0]?.list?.filter(
//   //    (item)=>((item?.banner_type === 0))
//   //   );
//   //   setData(() => uniqueList);
//   // }, [sliderData]);

//   //  console.log(sliderData, sliderData[0]?.list?.filter(
//   //    (item)=>((item?.banner_type === 0))
//   // ),  "SLiderDAta")

//   // Focus management
//   useEffect(() => {
//     if (shouldFocusSlider && sliderRef.current) {
//       sliderRef.current.focus();
//     }
//   }, [shouldFocusSlider, currentIndex]);

//   function sliderClikkHandler() {
//     navigateToScreen(
//       "DetailsScreen",
//       sliderData[0]?.list?.filter((item) => item?.banner_type === 0)[
//       currentIndex
//       ]
//     );
//     setRememberFocus((prev) => ({ ...prev, sliderIndex: currentIndex }));
//     if (lastFocusedElement3) lastFocusedElement3();
//   }

//   const loadData = async () => {
//     const userId = localStorage.getItem("profileId");
//     const getCountry = localStorage.getItem("country");

//     let headers = {
//       iskid: "0",
//       Langid: "1",
//       "Content-Type": "application/json",
//       country: getCountry,
//       age: "12",
//     };

//     try {
//       const filteredList = sliderData[0]?.list?.filter(item => item?.banner_type === 0);
//       const selectedItem = filteredList?.[currentIndex];

//       const showOrId = selectedItem?.show_id || selectedItem?.id;

//       const [fetchedItemDetails, fetchVideoUrl] = await Promise.all([
//         // Fetch content details
//         getContentDetails(showOrId),

//         // Fetch video URL
//         (async () => {
//           const videoID =
//             selectedItem?.video_id ||
//             selectedItem?.show_id ||
//             (
//               await getContentDetails(selectedItem?.id)
//             )?.data?.season?.[0]?.videos?.[0]?.id;

//           if (!videoID) {
//             console.warn("Unable to determine video ID");
//             return null;
//           }

//           // Here you'd fetch the actual video URL if needed, e.g.:
//           // return await getVideoUrl(videoID);
//           return videoID; // returning ID for now as placeholder
//         })(),
//       ]);

//       contentDetails = fetchedItemDetails?.data?.pricing?.gst_amount + fetchedItemDetails?.data?.pricing?.s_price

//       console.log("Details Screen....", fetchedItemDetails, fetchVideoUrl);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   useEffect(() => {
//     loadData();
//     return () => { };
//   }, []);

//   // Keyboard event handler
//   useEffect(() => {
//     if (!shouldFocusSlider) return;

//     const bannerKeyHandler = (event) => {
//       switch (event.keyCode) {
//         case 13: // Enter
//           navigateToScreen(
//             "DetailsScreen",
//             sliderData[0]?.list?.filter((item) => item?.banner_type === 0)[
//             currentIndex
//             ]
//           );
//           setRememberFocus((prev) => ({ ...prev, sliderIndex: currentIndex }));
//           if (lastFocusedElement3) lastFocusedElement3();
//           break;
//         case 39: // Right arrow
//           goToNext();
//           break;
//         case 37: // Left arrow
//           goToPrevious();
//           break;
//         case 40: // Down arrow
//           FocusHandler("AnimatedGrid");
//           break;
//         case 38: // Up arrow
//           FocusHandler("RowList");
//           break;
//         case 8: // Back button
//         case 10009:
//         case 461:
//           callBack("AnimatedGrid", true);
//           break;
//         default:
//           break;
//       }
//     };

//     // console.log(data, "123456");

//     window.addEventListener("keydown", bannerKeyHandler);
//     return () => window.removeEventListener("keydown", bannerKeyHandler);
//   }, [
//     shouldFocusSlider,
//     currentIndex,
//     sliderData,
//     FocusHandler,
//     navigateToScreen,
//   ]);

//   console.log("sliderData[0]...", sliderData[0]);

//   return (
//     <div
//       ref={sliderRef}
//       tabIndex={shouldFocusSlider ? 0 : -1}
//       className={shouldFocusToGrid ? "slide-up-hide" : "slide-down-show"}
//       style={{
//         position: "relative",
//         width: "90vw",
//         height: "800px",
//         overflow: "hidden",
//         padding: "20px",
//         marginBottom: "3rem",
//         outline: "none",
//       }}
//     >
//       {sliderData[0]?.list
//         ?.filter((item) => item?.banner_type === 0)
//         ?.map((image, index) => (
//           <img
//             key={index}
//             src={image.banner_url}
//             alt={`Slide ${index + 1}`}
//             style={{
//               display: index === currentIndex ? "block" : "none",
//               width: "100%",
//               height: "100%",
//               objectFit: "fill",
//               borderRadius: "25px",
//             }}
//           />
//         ))}

//       <div
//         style={{
//           position: "absolute",
//           top: "20px",
//           left: "20px",
//           right: "20px",
//           bottom: "20px",
//           borderRadius: "25px",
//           background: "linear-gradient(to top right, #000037, #FFFFFF)",
//           zIndex: 1,
//           opacity: 0.4,
//         }}
//       />
//       {/* {console.log(data, "1234567")} */}
//       {sliderData[0]?.list?.filter((item) => item?.banner_type === 0)[
//         currentIndex
//       ] && (
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               paddingLeft: "7%",
//               top: "15rem",
//               zIndex: 2,
//               color: "#fff",
//               width: "30vw",
//               position: "absolute",
//             }}
//           >
//             <h2
//               style={{
//                 fontWeight: "bold",
//                 fontSize: "3rem",
//                 lineHeight: "1",
//                 textTransform: "uppercase",
//                 zIndex: 2,
//                 margin: "0",
//               }}
//             >
//               {
//                 sliderData[0]?.list?.filter((item) => item?.banner_type === 0)[
//                   currentIndex
//                 ]?.title
//               }
//             </h2>

//             <p style={{ fontSize: "1.5rem", lineHeight: "1.5" }}>
//               {`${sliderData[0]?.list
//                 ?.filter((item) => item?.banner_type === 0)
//               [currentIndex]?.description[0]?.content?.slice(0, 100)}...`}
//             </p>

//             <p style={{ fontSize: "1.5rem", lineHeight: "1.5" }}>
//               {`${sliderData[0]?.list
//                 ?.filter((item) => item?.banner_type === 0)
//               [currentIndex]?.genre_titles?.split(",")
//                 .join(" | ")}`}
//             </p>

//             <CustomButton
//               isLiveText={
//                 sliderData[0]?.list?.filter((item) => item?.banner_type === 0)[
//                   currentIndex
//                 ]?.is_live === 0 &&
//                 sliderData[0]?.list?.filter((item) => item?.banner_type === 0)[
//                   currentIndex
//                 ]?.live_date_time > 1
//               }
//               navigateTo="/login"
//               fontSize={resolution === "FHD" ? "26px" : "18px"}
//               defaultSelected={true}
//               width={resolution === "FHD" ? "254px" : "169px"}
//               height={resolution === "FHD" ? "80px" : "53px"}
//               className="carousel-image"
//               style={{
//                 opacity: 1,
//                 transition: "opacity 1s",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 gap: "0.8rem",
//                 fontWeight: "bold",
//                 zIndex: 2,
//                 border: "none",
//                 position: "relative",
//                 margin: "0",
//               }}
//               onClick={sliderClikkHandler}
//             >
//               <div>
//                 {(sliderData[0]?.list?.filter((item) => item?.banner_type === 0)[
//                   currentIndex
//                 ]?.live_date_time &&
//                   sliderData[0]?.list?.filter((item) => item?.banner_type === 0)[
//                     currentIndex
//                   ]?.live_end_time > 1) ||
//                   (sliderData[0]?.list?.filter((item) => item?.banner_type === 0)[
//                     currentIndex
//                   ]?.live_date_time === 0 &&
//                     sliderData[0]?.list?.filter((item) => item?.banner_type === 0)[
//                       currentIndex
//                     ]?.live_end_time === 0) ? (
//                   <img
//                     src="./assets/playbuttonicon.png"
//                     style={{
//                       width: resolution === "FHD" ? "26px" : "18px",
//                       height: resolution === "FHD" ? "31px" : "22px",
//                     }}
//                     alt="Play Button"
//                   />
//                 ) : null}
//               </div>

//               <div>
//                 {
//                   sliderData[0]?.list?.filter(item => item?.banner_type === 0)[currentIndex]?.is_paid === 2 || sliderData[0]?.list?.filter(item => item?.banner_type === 0)[currentIndex]?.is_paid === 3 ? (
//                     window.IS_ON_RENT !== 1
//                       ? `Available to rent at ₹${contentDetails}`
//                       : "Watch Now"
//                   ) :
//                     sliderData[0]?.list?.filter((item) => item?.banner_type === 0)[
//                       currentIndex
//                     ]?.media_type === 1 ? (
//                       <Translate langKey="Listennow" />
//                     ) : sliderData[0]?.list?.filter(
//                       (item) => item?.banner_type === 0
//                     )[currentIndex]?.is_live === 0 ? (
//                       sliderData[0]?.list?.filter((item) => item?.banner_type === 0)[
//                         currentIndex
//                       ]?.live_date_time ? (
//                         isTimeExpired(
//                           sliderData[0]?.list?.filter(
//                             (item) => item?.banner_type === 0
//                           )[currentIndex]?.live_date_time
//                         ) ? (
//                           "Watch since"
//                         ) : (
//                           `Begins on ${formatUnixToDate(
//                             sliderData[0]?.list?.filter(
//                               (item) => item?.banner_type === 0
//                             )[currentIndex]?.live_date_time
//                           )}`
//                         )
//                       ) : (
//                         <Translate langKey="Watchnow" />
//                       )
//                     ) : (
//                       <Translate langKey="Watchnow" />
//                     )}
//               </div>
//             </CustomButton>
//           </div>
//         )}

//       <div
//         style={{
//           position: "absolute",
//           bottom: "50px",
//           left: "50%",
//           transform: "translateX(-50%)",
//           display: "flex",
//           gap: "10px",
//           zIndex: 2,
//         }}
//       >
//         {sliderData[0]?.list
//           ?.filter((item) => item?.banner_type === 0)
//           .map((_, index) => (
//             <span
//               key={index}
//               onClick={() => goToSlide(index)}
//               style={{
//                 height: "12px",
//                 width: "12px",
//                 borderRadius: "50%",
//                 display: "inline-block",
//                 backgroundColor:
//                   index === currentIndex && shouldFocusSlider
//                     ? "#EC008C"
//                     : "#FFF",
//                 cursor: "pointer",
//                 transition: "background-color 0.3s ease",
//               }}
//             />
//           ))}
//       </div>
//     </div>
//   );
// };

// export default SliderBanner;

// import React, { useState, useEffect, useRef } from "react";
// import CustomButton from "./CustomButton";
// import { Translate } from "./LanguageChanger";

// const SliderBanner = ({
//   sliderData,
//   shouldFocusSlider,
//   shouldFocusToGrid,
//   FocusHandler,
//   navigateToScreen,
//   callBack,
//   rememberFocus,
//   setRememberFocus,
//   lastFocusedElement3,
//   rowHeight, // Current row height from AnimatedGrid
//   newTop, // Current top position from AnimatedGrid
// }) => {
//   const sliderRef = useRef(null);
//   const [currentIndex, setCurrentIndex] = useState(
//     rememberFocus?.sliderIndex !== undefined ? rememberFocus.sliderIndex : 0
//   );
//   const [currentPosition, setCurrentPosition] = useState(0);

//   let resolution = window.innerWidth > 768 ? "FHD" : "HD";

//   // Update position when newTop changes
//   useEffect(() => {
//     if (newTop !== undefined) {
//       setCurrentPosition(newTop);
//     }
//   }, [newTop]);

//   useEffect(() => {
//     if (rememberFocus?.sliderIndex !== undefined) {
//       setCurrentIndex(rememberFocus.sliderIndex);
//     }
//   }, [rememberFocus]);

//   function goToNext() {
//     const filteredList = sliderData[0]?.list?.filter(item => item?.banner_type === 0) || [];
//     if (currentIndex < filteredList.length - 1) {
//       const newIndex = currentIndex + 1;
//       setCurrentIndex(newIndex);
//       setRememberFocus((prev) => ({ ...prev, sliderIndex: newIndex }));
//     }
//   }

//   function goToPrevious() {
//     if (currentIndex > 0) {
//       const newIndex = currentIndex - 1;
//       setCurrentIndex(newIndex);
//       setRememberFocus((prev) => ({ ...prev, sliderIndex: newIndex }));
//     } else {
//       callBack("AnimatedGrid", true);
//     }
//   }

//   const goToSlide = (index) => {
//     setCurrentIndex(index);
//     setRememberFocus((prev) => ({ ...prev, sliderIndex: index }));
//   };

//   function formatUnixToDate(unixTimestamp) {
//     const date = new Date(unixTimestamp * 1000);
//     const day = date.getDate();
//     const monthNames = [
//       "Jan", "Feb", "Mar", "Apr", "May", "Jun",
//       "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
//     ];
//     const month = monthNames[date.getMonth()];
//     const year = date.getFullYear();
//     const hours = date.getHours();
//     const minutes = date.getMinutes();
//     const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
//     const ampm = hours >= 12 ? "PM" : "AM";
//     const formattedHours = hours % 12 || 12;

//     const ordinalSuffix = (n) => {
//       if (n > 3 && n < 21) return "th";
//       switch (n % 10) {
//         case 1: return "st";
//         case 2: return "nd";
//         case 3: return "rd";
//         default: return "th";
//       }
//     };

//     const dayWithSuffix = `${day}${ordinalSuffix(day)}`;
//     return `${dayWithSuffix} ${month} ${year}, ${formattedHours}:${formattedMinutes} ${ampm}`;
//   }

//   function isTimeExpired(unixTimestamp) {
//     const currentTime = Math.floor(Date.now() / 1000);
//     return currentTime > unixTimestamp;
//   }

//   useEffect(() => {
//     if (shouldFocusSlider && sliderRef.current) {
//       sliderRef.current.focus();
//     }
//   }, [shouldFocusSlider]);

//   function sliderClickHandler() {
//     const currentItem = sliderData[0]?.list?.filter(item => item?.banner_type === 0)[currentIndex];
//     if (currentItem) {
//       navigateToScreen("DetailsScreen", currentItem);
//       setRememberFocus((prev) => ({ ...prev, sliderIndex: currentIndex }));
//       if (lastFocusedElement3) lastFocusedElement3();
//     }
//   }

//   useEffect(() => {
//     if (!shouldFocusSlider) return;

//     const bannerKeyHandler = (event) => {
//       switch (event.keyCode) {
//         case 13: // Enter
//           sliderClickHandler();
//           break;
//         case 39: // Right arrow
//           goToNext();
//           break;
//         case 37: // Left arrow
//           goToPrevious();
//           break;
//         case 40: // Down arrow
//           FocusHandler("AnimatedGrid");
//           break;
//         case 38: // Up arrow
//           FocusHandler("RowList");
//           break;
//         case 8: // Back button
//         case 10009:
//         case 461:
//           callBack("AnimatedGrid", true);
//           break;
//         default:
//           break;
//       }
//     };

//     window.addEventListener("keydown", bannerKeyHandler);
//     return () => window.removeEventListener("keydown", bannerKeyHandler);
//   }, [shouldFocusSlider, currentIndex, sliderData, FocusHandler, navigateToScreen]);

//   const filteredBanners = sliderData[0]?.list?.filter(item => item?.banner_type === 0) || [];
//   const currentBanner = filteredBanners[currentIndex];

//   return (
//     <div
//       ref={sliderRef}
//       tabIndex={shouldFocusSlider ? 0 : -1}
//       style={{
//         position: "relative",
//         width: "90vw",
//         height: "800px",
//         overflow: "hidden",
//         padding: "20px",
//         marginBottom: "3rem",
//         outline: "none",
//         top: `${currentPosition}px`,
//         transition: "none"
//       }}
//     >
//       {filteredBanners.map((image, index) => (
//         <img
//           key={index}
//           src={image.banner_url}
//           alt={`Slide ${index + 1}`}
//           style={{
//             display: index === currentIndex ? "block" : "none",
//             width: "100%",
//             height: "100%",
//             objectFit: "fill",
//             borderRadius: "25px",
//           }}
//         />
//       ))}

//       <div
//         style={{
//           position: "absolute",
//           top: "20px",
//           left: "20px",
//           right: "20px",
//           bottom: "20px",
//           borderRadius: "25px",
//           background: "linear-gradient(to top right, #000037, #FFFFFF)",
//           zIndex: 1,
//           opacity: 0.4,
//         }}
//       />

//       {currentBanner && (
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             paddingLeft: "7%",
//             top: "15rem",
//             zIndex: 2,
//             color: "#fff",
//             width: "30vw",
//             position: "absolute",
//           }}
//         >
//           <h2
//             style={{
//               fontWeight: "bold",
//               fontSize: "3rem",
//               lineHeight: "1",
//               textTransform: "uppercase",
//               zIndex: 2,
//               margin: "0",
//             }}
//           >
//             {currentBanner.title}
//           </h2>

//           <p style={{ fontSize: "1.5rem", lineHeight: "1.5" }}>
//             {currentBanner.description?.[0]?.content?.slice(0, 100) + "..."}
//           </p>

//           <p style={{ fontSize: "1.5rem", lineHeight: "1.5" }}>
//             {currentBanner.genre_titles?.split(",").join(" | ")}
//           </p>

//           <CustomButton
//             isLiveText={
//               currentBanner.is_live === 0 &&
//               currentBanner.live_date_time > 1
//             }
//             onClick={sliderClickHandler}
//             fontSize={resolution === "FHD" ? "26px" : "18px"}
//             defaultSelected={true}
//             width={resolution === "FHD" ? "254px" : "169px"}
//             height={resolution === "FHD" ? "80px" : "53px"}
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: "0.8rem",
//               fontWeight: "bold",
//               zIndex: 2,
//               border: "none",
//               position: "relative",
//               margin: "0",
//             }}
//           >
//             <div>
//               {(currentBanner.live_date_time && currentBanner.live_end_time > 1) ||
//               (currentBanner.live_date_time === 0 && currentBanner.live_end_time === 0) ? (
//                 <img
//                   src="./assets/playbuttonicon.png"
//                   style={{
//                     width: resolution === "FHD" ? "26px" : "18px",
//                     height: resolution === "FHD" ? "31px" : "22px",
//                   }}
//                   alt="Play Button"
//                 />
//               ) : null}
//             </div>

//             <div>
//               {currentBanner.media_type === 1 ? (
//                 <Translate langKey="Listennow" />
//               ) : currentBanner.is_live === 0 ? (
//                 currentBanner.live_date_time ? (
//                   isTimeExpired(currentBanner.live_date_time) ? (
//                     "Watch since"
//                   ) : (
//                     `Begins on ${formatUnixToDate(currentBanner.live_date_time)}`
//                   )
//                 ) : (
//                   <Translate langKey="Watchnow" />
//                 )
//               ) : (
//                 <Translate langKey="Watchnow" />
//               )}
//             </div>
//           </CustomButton>
//         </div>
//       )}

//       <div
//         style={{
//           position: "absolute",
//           bottom: "50px",
//           left: "50%",
//           transform: "translateX(-50%)",
//           display: "flex",
//           gap: "10px",
//           zIndex: 2,
//         }}
//       >
//         {filteredBanners.map((_, index) => (
//           <span
//             key={index}
//             onClick={() => goToSlide(index)}
//             style={{
//               height: "12px",
//               width: "12px",
//               borderRadius: "50%",
//               display: "inline-block",
//               backgroundColor: index === currentIndex && shouldFocusSlider
//                 ? "#EC008C"
//                 : "#FFF",
//               cursor: "pointer",
//             }}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default SliderBanner;

import React, { useState, useEffect, useRef, useContext } from "react";
import CustomButton from "./CustomButton";
import { Translate } from "./LanguageChanger";
import { getContentDetails } from "../services/services";
import upcomingImg from "../assets/upcoming.png";
import premium from "../assets/Premium.png";
import rent from "../assets/Rent.png";
import playIcon from "../assets/playbuttonicon.png";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";
import { AppContext } from "../AppContext";
import gradientImage from "../assets/backgroundgradient.webp";
import { sendSliderBannerEvent } from "../Analytics/MatomoManager/homeScreenMatomo";

let subscriptionCheck = false;

const SliderBanner = ({
  sliderData,
  shouldFocusSlider,
  shouldFocusToGrid,
  FocusHandler,
  navigateToScreen,
  callBack,
  rememberFocus,
  setRememberFocus,
  lastFocusedElement3,
  shouldAuthError,
  shouldShowError
}) => {

  const sliderRef = useRef(null);
  console.log(
    "SliderBanner data",
    rememberFocus,
    "nextFunc",
    lastFocusedElement3
  );
  const [currentIndex, setCurrentIndex] = useState(
    rememberFocus?.sliderIndex !== undefined ? rememberFocus.sliderIndex : 0
  );
  const [contentDetailsMap, setContentDetailsMap] = useState({});
  const { sourceContext, setSourceContext } = useContext(AppContext);


  let resolution = window.innerWidth > 768 ? "FHD" : "HD";

  let userDetails = JSON.parse(localStorage.getItem("user_details"));
  // let userProfile = userDetails?.user_profiles?.[0];
  const subscriptionsArray =
    userDetails?.user_profiles?.[0]?.subscriptions || [];

  const itemDetails = sliderData[0]?.list?.filter(
    (item) => item?.banner_type === 0
  )[currentIndex];

  const plans =
    typeof itemDetails?.plans === "string"
      ? itemDetails?.plans?.split(",").map(Number)
      : typeof itemDetails?.plans === "number"
        ? [itemDetails?.plans]
        : itemDetails?.plans;

  function arraysEqual(a, b) {
    console.log("arraysEqual called", a, b);

    if (!Array.isArray(a) || !Array.isArray(b)) return false;
    if (a.length !== b.length) return false;

    for (let i = 0; i < a.length; i++) {
      const valA =
        typeof a[i] === "object" && a[i] !== null ? a[i].publisherId : a[i];
      const valB =
        typeof b[i] === "object" && b[i] !== null ? b[i].publisherId : b[i];
      if (valA !== valB) return false;
    }

    return true;
  }

  function arraysEquals(a, b) {
    console.log("arraysEquals called", a, b);

    // Check if both are arrays
    if (!Array.isArray(a) || !Array.isArray(b)) return false;

    // Check if lengths match
    if (a.length !== b.length) return false;

    // Check each element
    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }

    // All elements matched
    return true;
  }


  subscriptionCheck =
    // banneritems[currentIndex].plans !== null
    itemDetails?.plans === null
      ? arraysEqual(window.PUBLISHERID, subscriptionsArray)
      : arraysEquals(window.PLANSIDS, plans);

  // Initialize currentIndex from rememberFocus when component mounts
  useEffect(() => {
    if (rememberFocus?.sliderIndex !== undefined) {
      setCurrentIndex(rememberFocus.sliderIndex);
    }
  }, [rememberFocus]);

  function goToNext() {
    const filteredLength = sliderData[0]?.list?.filter((item) => item?.banner_type === 0).length || 0;
    if (filteredLength > 0) {
      const newIndex = (currentIndex + 1) % filteredLength;
      setCurrentIndex(newIndex);
      // Update rememberFocus with the new index
      setRememberFocus((prev) => ({ ...prev, sliderIndex: newIndex }));
    }
  }

  function goToPrevious() {
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1;
      setCurrentIndex(newIndex);
      setRememberFocus((prev) => ({ ...prev, sliderIndex: newIndex }));
    } else {
      callBack("AnimatedGrid", true);
    }
  }

  const goToSlide = (index) => {
    setCurrentIndex(index);
    setRememberFocus((prev) => ({ ...prev, sliderIndex: index }));
  };

  function formatUnixToDate(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000);
    const day = date.getDate();
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;

    const ordinalSuffix = (n) => {
      if (n > 3 && n < 21) return "th";
      switch (n % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    const dayWithSuffix = `${day}${ordinalSuffix(day)}`;
    return `${dayWithSuffix} ${month} ${year}, ${formattedHours}:${formattedMinutes} ${ampm}`;
  }

  function isTimeExpired(unixTimestamp) {
    console.log("unixTimestamp...", unixTimestamp);
    const currentTime = Math.floor(Date.now() / 1000);
    console.log(currentTime);
    return currentTime > unixTimestamp;
  }

  console.log(sliderData, "SLiderDAta");

  // Focus management
  useEffect(() => {
    if (shouldFocusSlider && sliderRef.current) {
      sliderRef.current.focus();
    }
  }, [shouldFocusSlider, currentIndex]);

  function sliderClikkHandler() {
    setSourceContext("Home/Tag(0/All/(Banner)");
    navigateToScreen(
      "HomeDetailsScreen",
      sliderData[0]?.list?.filter((item) => item?.banner_type === 0)[
      currentIndex
      ]
    );
    setRememberFocus((prev) => ({ ...prev, sliderIndex: currentIndex }));
    if (lastFocusedElement3) lastFocusedElement3();
  }

  const loadData = async () => {
    const userId = localStorage.getItem("profileId");
    const getCountry = localStorage.getItem("country");

    let headers = {
      iskid: "0",
      Langid: "1",
      "Content-Type": "application/json",
      country: getCountry,
      age: "12",
    };

    try {
      const filteredList = sliderData[0]?.list?.filter(
        (item) => item?.banner_type === 0
      );

      // Load data for all banners upfront
      const detailsPromises = filteredList.map(async (item) => {
        const showOrId = item?.show_id || item?.id;
        try {
          const details = await getContentDetails(showOrId);
          return {
            id: item.id,
            price:
              details?.data?.pricing?.gst_amount +
              details?.data?.pricing?.s_price,
          };
        } catch (error) {
          console.error(`Error fetching details for item ${item.id}:`, error);
          return {
            id: item.id,
            price: null,
          };
        }
      });

      const detailsResults = await Promise.all(detailsPromises);

      // Convert to a map for easy lookup
      const detailsMap = detailsResults.reduce((acc, curr) => {
        acc[curr.id] = curr.price;
        return acc;
      }, {});

      setContentDetailsMap(detailsMap);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };



  // Keyboard event handler
  useEffect(() => {
    if (!shouldFocusSlider) return;

    const bannerKeyHandler = (event) => {
      if (shouldAuthError || shouldShowError) return;
      switch (event.keyCode) {
        case 13: // Enter
          navigateToScreen(
            "HomeDetailsScreen",
            sliderData[0]?.list?.filter((item) => item?.banner_type === 0)[
            currentIndex
            ]
          );
          setRememberFocus((prev) => ({ ...prev, sliderIndex: currentIndex }));
          if (lastFocusedElement3) lastFocusedElement3();
          setSourceContext("Home/Tag(0/All)/(Banner)");
          sendSliderBannerEvent(sliderData, currentIndex);
          break;
        case 39: // Right arrow
          goToNext();
          break;
        case 37: // Left arrow
          goToPrevious();
          break;
        case 40: // Down arrow
          FocusHandler("AnimatedGrid");
          break;
        case 38: // Up arrow
          FocusHandler("RowList");
          break;
        case 8: // Back button
        case 10009:
        case 461:
          callBack("AnimatedGrid", true);
          break;
        default:
          break;
      }
    };

    window.addEventListener("keydown", bannerKeyHandler);
    return () => window.removeEventListener("keydown", bannerKeyHandler);
  }, [
    shouldFocusSlider,
    currentIndex,
    sliderData,
    FocusHandler,
    navigateToScreen,
  ]);

  console.log("sliderData[0]...", sliderData[0]);

  const currentItem = sliderData[0]?.list?.filter(
    (item) => item?.banner_type === 0
  )[currentIndex];
  const currentContentDetails = currentItem
    ? contentDetailsMap[currentItem.id]
    : null;

  const isUpcomingButton = currentItem?.is_live === 0 && currentItem?.live_date_time > 1;

  return (
    <div
      ref={sliderRef}
      tabIndex={shouldFocusSlider ? 0 : -1}
      className={shouldFocusToGrid ? "slide-up-hide" : "slide-down-show"}
      style={{
        position: "relative",
        width: "90vw",
        height: "800px",
        overflow: "hidden",
        padding: "20px",
        marginBottom: "3rem",
        outline: "none",
      }}
    >
      {sliderData[0]?.list
        ?.filter((item) => item?.banner_type === 0)
        ?.map((image, index) => (
          <img
            // decoding="async"
            // loading="lazy"
            key={index}
            src={image.banner_url}
            alt={`Slide ${index + 1}`}
            style={{
              display: index === currentIndex ? "block" : "none",
              width: "100%",
              height: "100%",
              objectFit: "fill",
              borderRadius: "25px",
            }}
          />
        ))}

      <div
        style={{
          position: "absolute",
          top: "20px",
          left: "20px",
          right: "20px",
          bottom: "20px",
          borderRadius: "25px",
          background: `url(${gradientImage})`,
          // background: "linear-gradient(to top right, #000037, #FFFFFF)",
          // background: "linear-gradient(to top right, #000037 0%, #000037 40%, #FFFFFF 100%)",
          zIndex: 1,
          opacity: 0.4,
        }}
      />

      {currentItem && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            paddingLeft: "4%",
            top: "18rem",
            zIndex: 2,
            color: "#fff",
            width: "40vw",
            position: "absolute",
          }}
        >
          <h2
            style={{
              fontWeight: "bold",
              fontSize: "3rem",
              lineHeight: "1",
              textTransform: "uppercase",
              zIndex: 2,
              margin: "0",
            }}
          >
            {currentItem?.title}
          </h2>

          <p style={{ fontSize: "1.5rem", lineHeight: "1.5" }}>
            {`${currentItem?.description[0]?.content?.slice(0, 100)}...`}
          </p>

          <p style={{ fontSize: "1.5rem", lineHeight: "1.5" }}>
            {`${currentItem?.genre_titles?.split(",").join(" | ")}`}
          </p>

          <CustomButton
            isLiveText={isUpcomingButton}
            navigateTo="/login"
            fontSize={resolution === "FHD" ? "26px" : "18px"}
            defaultSelected={true}
            // width={resolution === "FHD" ? "254px" : "169px"}
            height={resolution === "FHD" ? "80px" : "53px"}
            className="carousel-image"
            style={{
              opacity: 1,
              transition: "opacity 1s",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.8rem",
              fontWeight: "bold",
              zIndex: 2,
              border: "none",
              position: "relative",
              margin: "0",
              backgroundColor: isUpcomingButton ? (shouldFocusSlider ? '#FFFFFF' : '#0E1653') : (shouldFocusSlider ? '#EC008C' : '#0E1653'),
              color: isUpcomingButton ? (shouldFocusSlider ? '#000000' : '#FFFFFF') : '#FFFFFF',
              // top: "2rem",
            }}
            onClick={sliderClikkHandler}
          >
            <div>
              {/* Hide play button for upcoming/scheduled content */}
              {!(currentItem?.isTeaser == 1 && parseInt(currentItem?.starttime) * 1000 > Date.now()) &&
                !(currentItem?.is_live === 0 && currentItem?.live_date_time && !isTimeExpired(currentItem?.live_date_time)) && (
                  <>
                    {currentItem?.is_paid === 2 || currentItem?.is_paid === 3 ? (
                      window.IS_ON_RENT !== 1 ? (
                        ""
                      ) : <img
                        src="./assets/playbuttonicon.png"
                        style={{
                          width: resolution === "FHD" ? "28px" : "18px",
                          height: resolution === "FHD" ? "28px" : "22px",
                        }}
                        alt="Play Button"
                      />
                    ) : <img
                      src="./assets/playbuttonicon.png"
                      style={{
                        width: resolution === "FHD" ? "28px" : "18px",
                        height: resolution === "FHD" ? "28px" : "22px",
                      }}
                      alt="Play Button"
                    />}
                  </>
                )}
            </div>

            <div style={{
              fontFamily: "Anek Latin",
              fontWeight: "500",
              fontSize: "1.75rem",
              paddingBottom: "4.5px"
            }}>
              {currentItem?.is_paid === 1 && !subscriptionCheck ? (
                <p>Subscribe to watch</p>
              ) : currentItem?.is_paid === 2 || currentItem?.is_paid === 3 ? (
                window.IS_ON_RENT !== 1 ? (
                  // `Available to rent at ₹${currentContentDetails || "..."}`
                  `Available to rent`
                ) : (
                  "Watch Now"
                )
              ) :
                currentItem?.isTeaser == 1 && parseInt(currentItem?.endtime) * 1000 > Date.now() ?
                  (`Streaming from ${formatUnixToDate(
                    currentItem?.endtime
                  )}`)


                  : currentItem?.media_type === 1 ? (
                    <Translate langKey="Listennow" />
                  ) : currentItem?.is_live === 0 ? (
                    currentItem?.live_date_time ? (
                      (console.log("currentItem..", currentItem),
                        isTimeExpired(currentItem?.live_date_time)
                          ? `Watch since ${formatUnixToDate(
                            currentItem?.live_date_time
                          )}`
                          : `Begins on ${formatUnixToDate(
                            currentItem?.live_date_time
                          )}`)
                    )
                      : (
                        <Translate langKey="Watchnow" />
                      )
                  ) : (
                    <Translate langKey="Watchnow" />
                  )}
            </div>
          </CustomButton>

          {/* <CustomButton
            isLiveText={isUpcomingButton}
            navigateTo="/login"
            fontSize={resolution === "FHD" ? "26px" : "18px"}
            defaultSelected={true}
            // width={resolution === "FHD" ? "254px" : "169px"}
            height={resolution === "FHD" ? "80px" : "53px"}
            className="carousel-image"
            style={{
              opacity: 1,
              transition: "opacity 1s",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.8rem",
              fontWeight: "bold",
              zIndex: 2,
              border: "none",
              position: "relative",
              margin: "0",
              backgroundColor: isUpcomingButton ? (shouldFocusSlider ? '#FFFFFF' : '#0E1653') : (shouldFocusSlider ? '#EC008C' : '#0E1653'),
              color: isUpcomingButton ? (shouldFocusSlider ? '#000000' : '#FFFFFF') : '#FFFFFF',
              // top: "2rem",
            }}
            onClick={sliderClikkHandler}
          >
           <div>
  {currentItem?.is_paid === 2 || currentItem?.is_paid === 3 ? (
    window.IS_ON_RENT !== 1 ? (
      ""
    ) : <img
        src="./assets/playbuttonicon.png"
        style={{
          height: resolution === "FHD" ? "31px" : "22px",
        }}
        alt="Play Button"
      />
  ) : <img
        src="./assets/playbuttonicon.png"
        style={{
          height: resolution === "FHD" ? "31px" : "22px",
        }}
        alt="Play Button"
      />}
</div>


            <div>
              {currentItem?.is_paid === 1 && !subscriptionCheck ? (
                <p>Subscribe to watch</p>
              ) : currentItem?.is_paid === 2 || currentItem?.is_paid === 3 ? (
                window.IS_ON_RENT !== 1 ? (
                  // `Available to rent at ₹${currentContentDetails || "..."}`
                  `Available to rent`
                ) : (
                  "Watch Now"
                )
              ) : currentItem?.media_type === 1 ? (
                <Translate langKey="Listennow" />
              ) : currentItem?.is_live === 0 ? (
                currentItem?.live_date_time ? (
                  (console.log("currentItem..", currentItem),
                  isTimeExpired(currentItem?.live_date_time)
                    ? `Watch since ${formatUnixToDate(
                        currentItem?.live_date_time
                      )}`
                    : `Begins on ${formatUnixToDate(
                        currentItem?.live_date_time
                      )}`)
                ) : (
                  <Translate langKey="Watchnow" />
                )
              ) : (
                <Translate langKey="Watchnow" />
              )}
            </div>
          </CustomButton> */}
        </div>
      )}

      <div
        style={{
          position: "absolute",
          bottom: "50px",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: "10px",
          zIndex: 2,
        }}
      >
        {/* {sliderData[0]?.list
          ?.filter((item) => item?.banner_type === 0)
          .map((_, index) => (
            <span
              key={index}
              onClick={() => goToSlide(index)}
              style={{
                height: "12px",
                width: "12px",
                borderRadius: "50%",
                display: "inline-block",
                backgroundColor:
                  index === currentIndex && shouldFocusSlider
                    ? "#EC008C"
                    : "#FFF",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
              }}
            />
          ))} */}
        {sliderData[0]?.list
          ?.filter((item) => item?.banner_type === 0)
          .map((_, index) => (
            <span
              key={index}
              onClick={() => goToSlide(index)}
              style={{
                height: "12px",
                width: "12px",
                borderRadius: "50%",
                display: "inline-block",
                backgroundColor:
                  index === currentIndex && shouldFocusSlider
                    ? "#EC008C"
                    : "#FFF",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
              }}
            />
          ))}

        {(() => {
          const currentItem = sliderData[0]?.list?.filter(
            (item) => item?.banner_type === 0
          )?.[currentIndex];

          if (currentItem?.isTeaser === 1) {
            const startTime = parseInt(currentItem?.endtime) * 1000;
            const now = Date.now();
            const hoursRemaining = (startTime - now) / (1000 * 60 * 60);
            const launchesIn48Hours =
              hoursRemaining > 0 && hoursRemaining <= 48;

            return (
              <>
                {launchesIn48Hours && (
                  <div
                    style={{
                      position: "absolute",
                      bottom: "10%",
                      left: "50%",
                      transform: "translateX(-50%)",
                      zIndex: 10,
                      background: "#fff",
                      color: "black",
                      padding: "5px 15px",
                      fontSize: "16px",
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                      textTransform: "uppercase",
                    }}
                  >
                    {/* {`LAUNCHES IN ${Math.ceil(hoursRemaining)} HOURS`} */}
                  </div>
                )}

                {/* <img
                  src={upcomingImg}
                  alt={currentItem?.title}
                  style={{
                    borderRadius: "10px",
                    position: "absolute",
                    width: "10vw",
                    height: "4vh",
                    top: "1vh",
                    right: "1rem",
                    zIndex: 1,
                  }}
                /> */}
              </>
            );
          }

          return null;
        })()}
      </div>
    </div>
  );
};

export default SliderBanner;